// extracted by mini-css-extract-plugin
export default {"CurPage":"CurPage_CurPage__6XWll","currentPage":"CurPage_currentPage__Z3GHR"};